module.exports = __webpack_public_path__ + "static/master-cards-pocket@2x-f71cc7ef1edb5ed01c57ea17b381ff64.png";